import React from 'react';
import { Box, Typography, Paper, Avatar } from '@mui/material';
import { Lightbulb } from '@mui/icons-material';
import AdminTipsComponent from '../../components/admin/AdminTips';

const AdminTips = () => {
    return (
        <Box sx={{ p: 3 }}>
            {/* Header */}
            <Paper elevation={4} sx={{
                mb: 4,
                p: 4,
                borderRadius: 3,
                background: 'linear-gradient(135deg, #4caf50, #66bb6a)',
                color: 'white'
            }}>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 3 }}>
                    <Avatar sx={{
                        background: 'rgba(255,255,255,0.2)',
                        backdropFilter: 'blur(10px)',
                        border: '3px solid rgba(255,255,255,0.3)',
                        width: 80,
                        height: 80
                    }}>
                        <Lightbulb sx={{ fontSize: 40 }} />
                    </Avatar>
                    <Box>
                        <Typography variant="h3" fontWeight={800} sx={{ mb: 1 }}>
                            Educational Tips Management
                        </Typography>
                        <Typography variant="h6" sx={{ opacity: 0.9 }}>
                            Manage Environmental Education Content
                        </Typography>
                        <Typography variant="body2" sx={{ opacity: 0.8, mt: 1 }}>
                            Create, edit, and manage educational tips for users
                        </Typography>
                    </Box>
                </Box>
            </Paper>

            {/* AdminTips Component */}
            <AdminTipsComponent />
        </Box>
    );
};

export default AdminTips;
